import isEmpty from 'lodash/isEmpty';
import upperFirst from 'lodash/upperFirst';
import { Link as RouterLink } from 'react-router-dom';

import { Student } from '../../../../../api/types/student';
import FilledExclamation from '../../../../../assets/images/icon-filled-alert-exclamation.svg';
import { ChevronDownIcon } from '../../../../../icons';
import { PATH_HUB_ADD_STUDENT } from '../../../../../util/pagePath';
import { cn } from '../../../../../v2/common/helpers/cn';

// TODO: Remove this when we have real data
const PLACEHOLDER_STUDENT_PATH = (studentId: string) => `/portal/customer/students/${studentId}/profile`;

export const StudentCardSkeleton = () => {
  return (
    <div className="flex animate-pulse flex-col gap-2 rounded-lg border border-grey-2 bg-grey-1 p-4">
      <div className="h-4 w-1/2 rounded-full bg-grey-2"></div>
      <div className="h-4 w-1/4 rounded-full bg-grey-2"></div>
      <div className="h-4 w-1/3 rounded-full bg-grey-2"></div>
    </div>
  );
};

export const StudentCard = ({ student, className }: { student: Student; className?: string }) => {
  return (
    <div
      className={cn(
        'flex w-60 flex-shrink-0 flex-col gap-2 rounded-lg border border-grey-2 bg-white p-4 text-sm shadow-md md:w-auto lg:flex-shrink',
        className
      )}
    >
      <div className="text-base font-semibold text-grey-600">
        {student.firstName}
        {student.currentYearLevel && ` | ${student.currentYearLevel}`}
      </div>
      <div className="flex-grow pb-2 text-grey-600">
        {!isEmpty(student.enrolments) ? (
          <>
            <p>Currently learning:</p>
            <p>{Object.keys(student.enrolments).map(upperFirst).join(', ')}</p>
          </>
        ) : (
          <p className="flex items-center">
            <img src={FilledExclamation} alt="warning" className="mr-2 h-4 w-4" /> No learning in progress
          </p>
        )}
      </div>
      <RouterLink
        to={PLACEHOLDER_STUDENT_PATH(student.studentId)}
        className="flex items-center justify-center gap-2 rounded-full border border-grey-400 px-4 py-[7px] text-center text-sm font-medium leading-5 tracking-normal text-grey-400 hover:bg-brown-100"
      >
        See Profile <ChevronDownIcon className="-rotate-90" height={10} width={10} />
      </RouterLink>
    </div>
  );
};

export const AddAStudentCard = ({ className }: { className?: string } = {}) => {
  return (
    <RouterLink
      to={PATH_HUB_ADD_STUDENT}
      className={cn(
        'flex w-60 flex-shrink-0 snap-center flex-col items-center justify-center gap-y-3 rounded-lg border-2 border-dashed border-grey-2 bg-white p-4 text-sm hover:bg-brown-100 md:w-auto',
        className
      )}
    >
      <div className="link text-base leading-4 tracking-normal underline underline-offset-0">+ Add a student</div>
      <div className="w-3/4 text-center text-sm leading-5 tracking-normal text-grey-600">
        Access unique content tailored to your specific needs
      </div>
    </RouterLink>
  );
};
